// Kasa → Banka Transferi penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'finance.cashboxBankTransfer';

export const cashboxBankTransferGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Kasadan bankaya transfer nasıl yapılır?'),
  intro: t(`${G}.intro`, 'Kasadaki nakdi bankaya yatırdığınızda bu pencereyle kaydedersiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve kaynak kasa'),
    body: t(`${G}.regions.body`, 'Transfer formu'),
    footer: t(`${G}.regions.footer`, 'Transferi Tamamla'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Kaynak kasayı kontrol edin'),
      text: t(`${G}.s1.text`, 'Üstteki kutu, paranın çıkacağı Kaynak Kasa adını ve güncel bakiyesini gösterir. Kaynak kasa, pencereyi açtığınız kasadır.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Banka hesabını ve alt hesabı seçin'),
      text: t(`${G}.s2.text`, '"Hedef Banka Hesabı" listesinde yalnız kasayla aynı para birimindeki banka hesapları çıkar. Hesabın alt hesapları varsa "Alt Hesap (Opsiyonel)" alanı açılır; alt hesap seçilmezse para ana banka hesabına yatırılır. Seçtiğiniz hesap ve mevcut bakiyesi "Hedef Hesap" kutusunda görünür.'),
      tips: [
        t(`${G}.s2.tip1`, '"Transfer edilebilecek banka hesabı bulunamadı" yazıyorsa kasanın para biriminde banka hesabınız yoktur.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Belge numarası, miktar, açıklama'),
      text: t(`${G}.s3.text`, 'Belge Numarası zorunludur; otomatik gelir (KBT-…), isterseniz banka dekont numarasıyla değiştirin. Miktar kasa bakiyesini aşamaz ("Maksimum transfer edilebilir" satırına bakın). Açıklama isteğe bağlıdır.'),
      tips: [
        t(`${G}.s3.tip1`, '"Geçmiş tarihli işlem yap" işaretlenirse İşlem Tarihi seçilir; transfer tamamen o tarihe kaydedilir. İleri tarih seçilemez.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Transferi tamamlayın'),
      text: t(`${G}.s4.text`, '"Transferi Tamamla" banka hesabı, miktar ve belge numarası dolunca açılır. Kayıttan sonra tutar kasadan çıkış olarak düşülür ve seçtiğiniz banka hesabının (veya alt hesabın) bakiyesine eklenir.'),
      tips: [
        t(`${G}.s4.tip1`, 'Kasada yeterli bakiye yoksa veya para birimleri farklıysa transfer yapılmaz ve hata mesajı çıkar.'),
      ],
    },
  ],
});
